<!-- Заголовок -->
<div class="mb-6">
  <h2 class="x-font-body-1-bold text-(--x-workflow-title) mb-2">
    Заполненные данные регламентов
  </h2>
</div>

<!-- Проверка на пустоту -->
@if ($submissions().length === 0) {
  <div class="flex flex-col items-center justify-center py-12 px-4 text-center">
    <tui-icon
      icon="@tui.info"
      class="text-(--x-text-03) mb-4 h-12! w-12! text-[3rem]"
    />
    <p class="x-font-body-3 text-(--x-workflow-text2) mb-2">Данных пока нет</p>
    <p class="x-font-body-4 text-(--x-workflow-text2)">
      Заполненные формы регламентов будут отображаться здесь
    </p>
  </div>
} @else {
  <!-- Группировка по регламентам -->
  <div class="space-y-4">
    @for (
      workflowGroup of $submissionsByWorkflow();
      track workflowGroup.workflowId
    ) {
      <div
        class="rounded-lg border border-(--x-workflow-border) bg-(--x-white) overflow-hidden"
      >
        <!-- Заголовок регламента -->
        <div
          class="px-4 py-3 bg-(--x-gray-01) border-b border-(--x-workflow-border) flex items-center justify-between"
        >
          <h3 class="x-font-body-2-bold text-(--x-workflow-title)">
            {{ workflowGroup.workflowName }}
          </h3>
          <span class="x-font-body-4 text-(--x-workflow-text2)">
            {{ workflowGroup.submissions.length }}
            {{ workflowGroup.submissions.length === 1 ? 'форма' : 'форм' }}
          </span>
        </div>

        <!-- Аккордеон с формами -->
        <tui-accordion class="border-0" [closeOthers]="false">
          @for (
            submission of workflowGroup.submissions;
            track submission.formId
          ) {
            <button
              type="button"
              class="w-full border-b border-(--x-workflow-border) last:border-b-0"
              [tuiAccordion]="submission.fields.length > 0"
            >
              <!-- Заголовок формы -->
              <div class="px-4 py-3">
                <div class="flex items-center gap-3 flex-1">
                  <!-- Иконка статуса -->
                  <div
                    class="flex items-center justify-center w-8 h-8 rounded-full transition-colors"
                    [ngClass]="{
                      'bg-green-100 text-(--x-green)': submission.isValid,
                      'bg-red-100 text-(--x-red)': !submission.isValid,
                    }"
                  >
                    <tui-icon
                      [icon]="
                        submission.isValid ? '@tui.check' : '@tui.circle-alert'
                      "
                      class="h-5! w-5! text-[1.25rem]"
                    />
                  </div>

                  <!-- Информация о форме -->
                  <div class="flex-1 min-w-0">
                    <div
                      class="x-font-body-3-bold text-(--x-workflow-title) mb-1"
                    >
                      {{ submission.nodeName }} → {{ submission.formTitle }}
                    </div>
                    @if (submission.submittedAt) {
                      <div class="x-font-body-5 text-(--x-workflow-text2) mb-1">
                        Отправлено: {{ formatDateTime(submission.submittedAt) }}
                      </div>
                    }
                    <!-- Бейдж количества полей -->
                    <div
                      class="x-font-body-5-bold inline-flex items-center px-2 py-0.5 rounded bg-(--x-gray-01) text-(--x-workflow-text2)"
                    >
                      @if (submission.fields.length > 0) {
                        {{ submission.fields.length }} полей заполнено
                      } @else {
                        Не заполнено
                      }
                    </div>
                  </div>
                </div>
              </div>
            </button>
            <!-- Содержимое формы -->
            <tui-expand>
              <div class="px-4 py-3 bg-(--x-gray-01)">
                <!-- Поля формы -->
                <div class="space-y-3">
                  @for (field of submission.fields; track field.key) {
                    <div
                      class="bg-(--x-white) rounded-lg p-3 border border-(--x-workflow-border)"
                    >
                      <!-- Заголовок поля -->
                      <div
                        class="x-font-body-5-bold text-(--x-workflow-text2) mb-1"
                      >
                        {{ field.title }}
                      </div>

                      <!-- Значение поля -->
                      <div class="x-font-body-4 text-(--x-workflow-title)">
                        @if (field.displayValue) {
                          <span class="break-words">{{
                            field.displayValue
                          }}</span>
                        }

                        <!-- Файлы (если есть) -->
                        @if (field.files && field.files.length > 0) {
                          <div class="mt-2 space-y-2">
                            @for (file of field.files; track file.id) {
                              <div>
                                @if (isImageFile(file.filename)) {
                                  <!-- Превью изображения -->
                                  <a
                                    [href]="file.url"
                                    target="_blank"
                                    class="block rounded-lg overflow-hidden border border-(--x-workflow-border) hover:border-(--x-workflow-title) transition-colors"
                                  >
                                    <img
                                      [src]="file.url"
                                      [alt]="file.filename"
                                      class="w-full h-auto max-h-48 object-cover"
                                    />
                                    <span
                                      class="x-font-body-5 block px-3 py-2 bg-(--x-gray-01) text-(--x-workflow-text2) truncate"
                                    >
                                      {{ file.filename }}
                                    </span>
                                  </a>
                                } @else {
                                  <!-- Ссылка на файл -->
                                  <a
                                    [href]="file.url"
                                    target="_blank"
                                    class="x-font-body-4 flex items-center gap-2 px-3 py-2 rounded-lg bg-(--x-gray-01) hover:bg-(--x-gray-02) text-(--x-workflow-title) hover:text-(--x-green) transition-colors"
                                  >
                                    <tui-icon
                                      icon="@tui.file"
                                      class="h-4! w-4! text-base flex-shrink-0"
                                    />
                                    <span class="truncate">{{
                                      file.filename
                                    }}</span>
                                  </a>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </tui-expand>
          }
        </tui-accordion>
      </div>
    }
  </div>
}
